import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { clientState, getOpponentLastPing } from './utils/photon/client';
import { ExternalLink } from './components/ExternalLink';
import { formatTime } from './utils/formatTime';
import { OPPONENT_CONSIDERED_OFFLINE_AFTER_SECONDS, CHECK_OPPENENT_ONLINE_EVERY_SECONDS } from './config/config';
import { sessionMatchesTracker } from './utils/game/tracker';
import './PlayersHeader.scss';


const OnlineIndicator = ({ currentUser, user }) => {
  const [opponentStatus, setOpponentStatus] = useState('🟢');

  useEffect(() => {
    const checkOpponentStatus = () => {
      let isOnline = true;
      const isLocalPlayerStatus = user === currentUser;
      const isLocalPlayerOnline = clientState.isConnected && navigator.onLine;
      if (isLocalPlayerStatus) { // local player
        isOnline = isLocalPlayerOnline;
      } else { // opponent
        const lastPing = getOpponentLastPing();
        isOnline = lastPing && ((Date.now() - lastPing) < (OPPONENT_CONSIDERED_OFFLINE_AFTER_SECONDS * 1000))
      }
      if (!isLocalPlayerStatus && !isLocalPlayerOnline) setOpponentStatus('❓'); // opponent status n/a
      else setOpponentStatus(isOnline ? '🟢' : '🔴');
    };
    const interval = setInterval(checkOpponentStatus, CHECK_OPPENENT_ONLINE_EVERY_SECONDS * 1000);
    return () => clearInterval(interval);
  }, []);

  return <span className="online-indicator">{opponentStatus}</span>
};


const PlayerInfo = ({ user, color, isRoomCreator, matchWinner }) => {
  const isLoser = matchWinner && matchWinner !== user && matchWinner !== 'DRAW';
  const matchOutcome = matchWinner && (matchWinner === user
    ? <p className="outcome-won">WINNER</p>
    : (matchWinner === 'DRAW' && <p className="outcome-draw">DRAW</p>));

  return (
    <div className="player-info">
      {/* online status */}
      {<OnlineIndicator {...{ currentUser: user, user }} />}
      {/* player pic */}
      <div
        className="player-pic"
        style={{ backgroundImage: `url(https://images.hive.blog/u/${user}/avatar)` }}
      ></div>
      {/* player name or outcome */}
      {(!matchWinner || isLoser)
          ? <div className="player-name">
              <ExternalLink href={`https://peakd.com/@${user}`}>{user}</ExternalLink>
              {isRoomCreator && <div id="room-creator-symbol">🛠️</div>}
            </div>
          : <div id="match-outcome">{matchOutcome}</div>
      }      
    </div>
  );
};


const Timer = ({ time, color, currentTurn }) => {
  return (
    <div
      className={`timer ${currentTurn === color.substring(0, 1) ? 'timer-ticking' : ''}`}
    >
      {formatTime(time)}
    </div>
  );
};

export const PlayersHeader = ({
  user, opponentName, color, isRoomCreator, time, currentTurn,
  inCheck, position, inExpiration, matchWinner
}) => {
  const won = matchWinner === user;
  const draw = matchWinner === 'DRAW';

  const { myVictories, myDefeats } = sessionMatchesTracker.matchesAgainst[opponentName] || {};
  const score = position === 'bottom' ? myVictories : myDefeats;

  const classnames = classNames(
    'player-header', 
    position, 
    {
      'in-check': inCheck,
      'expiring': inExpiration,
      won,
      draw,
    }
  );

  return (
    <div
      className={classnames}
    >
      <PlayerInfo {...{ user, color, isRoomCreator, matchWinner }} />

      <div className="right-group">
        {(myVictories || myDefeats) && <span className="score-display">{score}</span>}
        <Timer {...{ time, color, currentTurn }} />
      </div>
    </div>
  );
};
